import { render, staticRenderFns } from "./left.vue?vue&type=template&id=aa3d56c4&scoped=true&"
import script from "./left.vue?vue&type=script&lang=js&"
export * from "./left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3d56c4",
  null
  
)

export default component.exports